import { autoserialize, autoserializeAs } from 'cerialize';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util/is-null-or-defined';
import { DateUtil } from '@uzurv/rideWss/app/util/date.util';

export class Permission {
  @autoserialize
  id: number;

  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserializeAs(Date)
  createdDate: Date;

  @autoserializeAs(Date)
  modifiedDate: Date;

  /**** Serialization ****/

  static OnSerialized(instance: Permission, json: any): void {
    if (!isNullOrUndefined(instance.createdDate)) {
      json.createdDate = DateUtil.serializeDate(instance.createdDate);
    }
    if (!isNullOrUndefined(instance.modifiedDate)) {
      json.modifiedDate = DateUtil.serializeDate(instance.modifiedDate);
    }
  }

  static OnDeserialized(instance: Permission, json: any): void {
    if (!isNullOrUndefined(json['createdDate'])) {
      instance.createdDate = DateUtil.deserializeDate(json['createdDate']);
    }

    if (!isNullOrUndefined(json['modifiedDate'])) {
      instance.modifiedDate = DateUtil.deserializeDate(json['modifiedDate']);
    }
  }
}
